/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  LoadingDialog,
  Pagination,
} from "../../_metronic/_partials/controls";
import ReactSelect from "react-select";
import SVG from "react-inlinesvg";
import low from "lowdb";
import LocalStorage from "lowdb/adapters/LocalStorage";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import * as columnFormatters from "../modules/ECommerce/pages/products/products-table/column-formatters";
import {
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  toAbsoluteUrl,
} from "../../_metronic/_helpers";
import { Helmet } from "react-helmet";
import { RangeDatePicker } from "react-google-flight-datepicker";
import "react-google-flight-datepicker/dist/main.css";
import {
  ConvertToDateCurrentTimeZone,
  ConvertToDateGMT,
  ExportAs,
  formatPhoneNumber,
  translateAuto,
} from "../../_metronic/_helpers/AtHelper";
import { useTranslation } from "react-i18next";
import { Button, Col, Dropdown, Modal, Row, Spinner } from "react-bootstrap";
import { Formik } from "formik";
import PhoneInput from "react-phone-input-2";
import Swal from "sweetalert2";
import { DropdownCustomToggler } from "../../_metronic/_partials/dropdowns";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { InvoiceForm } from "../modules/ECommerce/pages/products/products-table/column-formatters/InvoicePdf";

const adapter = new LocalStorage("db");
const db = low(adapter);
const arrayBoolean = [
  { label: "All", value: "" },
  { label: "Yes", value: true },
  { label: "No", value: false },
];
const DateFiltersList = [
  { label: "Invoice date", value: "Invoice date" },
  { label: "Paid date", value: "Paid date" },
  { label: "Due date", value: "Due date" },
];
export default function InvoicesList() {
  const history = useHistory();
  const [InvoicesList, setInvoicesList] = useState(null);
  const [ViewModelOptions, setViewModelOptions] = useState(null);
  const [isLoadingAuth, setisLoadingAuth] = useState(false);
  const [isLoadingPutInvoice, setisLoadingPutInvoice] = useState(false);
  const [ShowModalPaid, setShowModalPaid] = useState(false);
  const [showModalInvoice, setshowModalInvoice] = useState(false);
  const [selectedInvoicePrint, setselectedInvoicePrint] = useState(null);
  const [SelectedInvoice, setSelectedInvoice] = useState(null);
  const [InvoiceDate, setInvoiceDate] = useState(null);
  const { t } = useTranslation();

  const [initFilter, setinitFilter] = useState({
    paid: "",
    modeId: [],
    filterDate: "",
    startDate: null,
    search: "",
    endDate: null,
    page: 1,
    sizePerPage: 10,
    sortField: "Id",
    sortOrder: "desc",
    custom: true,
    totalSize: 0,
    sizePerPageList: [
      { text: "5", value: 5 },
      { text: "10", value: 10 },
      { text: "25", value: 25 },
    ],
  });
  function getInvoicesList(props) {
    let ModeId = props.modeId;
    if (ModeId.length > 0) {
      var listmodeId = ModeId.map((a) => a.value);
      ModeId = "&modeId=" + listmodeId.join("&modeId=");
    } else {
      ModeId = "";
    }
    setisLoadingAuth(true);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${db.read().getState()?.Token}`);
    var requestOptions = {
      method: "GET",
      redirect: "follow",
      headers: myHeaders,
    };

    fetch(
      `${window.$apiurl}/api/Invoices?filterDate=${props.filterDate}${ModeId}&startDate=${props.startDate}&endDate=${props.endDate}&paid=${props.paid}&pageNumber=${props.page}&pageSize=${props.sizePerPage}&search=${props.search}&sortField=${props.sortField}&sortOrder=${props.sortOrder}`,
      requestOptions
    )
      .then(async (response) => {
        const statusCode = await response.status;
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          return response.json().then((data) => [statusCode, data]);
        } else {
          return response.text().then((text) => [statusCode, { Message: "" }]);
        }
      })
      .then((result) => {
        if (result[0] === 200) {
          var data = result[1];

          setInvoicesList(data);
          let paginationObj = { ...initFilter };
          paginationObj.totalSize = data.Pagination.TotalItemCount;
          paginationObj.page = data.Pagination.PageNumber;
          paginationObj.sizePerPage = data.Pagination.PageSize;
          paginationObj.sortOrder = props.sortOrder;
          paginationObj.sortField = props.sortField;
          paginationObj.modeId = props.modeId;
          paginationObj.paid = props.paid;
          paginationObj.search = props.search;
          paginationObj.filterDate = props.filterDate;
          paginationObj.StartDate = props.StartDate;
          paginationObj.EndDate = props.EndDate;
          setinitFilter(paginationObj);
        } else {
          if (
            result[1].ModelState !== null &&
            result[1].ModelState !== undefined &&
            result[1].ModelState !== ""
          ) {
            let modelState = result[1].ModelState;
            if (modelState)
              Object.keys(modelState).forEach(function(k) {
                modelState[k].forEach((element) => {
                  console.log("error", element);
                });
              });
          } else if (
            result[1].Message !== null &&
            result[1].Message !== undefined &&
            result[1].Message !== ""
          ) {
            console.log("error", result[1].Message);
          } else if (
            result[1].error_description !== null &&
            result[1].error_description !== undefined &&
            result[1].error_description !== ""
          ) {
            console.log("error", result[1].error_description);
          } else {
            console.log("error", "Bad request");
          }
        }
        setTimeout(() => {
          setisLoadingAuth(false);
        }, 500);
      })
      .catch((error) => {
        console.log("error", error);
      });
  }
  function getViewModel() {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${db.read().getState()?.Token}`);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${window.$apiurl}/api/Invoices/getViewModel`, requestOptions)
      .then(async (response) => {
        const statusCode = await response.status;
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          return response.json().then((data) => [statusCode, data]);
        } else {
          return response.text().then((text) => [statusCode, { Message: "" }]);
        }
      })
      .then((result) => {
        if (result[0] === 200) {
          setViewModelOptions(result[1]);
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  }
  useEffect(() => {
    getInvoicesList(initFilter);
    getViewModel();
  }, []);

  const columns = [
    {
      dataField: "Code",
      text: "Code",
      sort: true,
      sortCaret: sortCaret,
      formatter: (cell, row) => {
        return (
          <span
            style={{ cursor: "pointer" }}
            className="lbl lbl-link text-primary font-weight-bolder text-decoration-none"
            onClick={() => {
              history.push(`/shipper/Loads/${row.Id}/edit`);
            }}
          >
            {row.Code}
          </span>
        );
      },
    },
    {
      dataField: "Mode",
      text: "Mode",
      sort: true,
      sortCaret: sortCaret,
      formatter: (cell, row) => {
        return row.Mode;
      },
    },
    {
      dataField: "EquipmentType",
      text: "Equipment type",
      sort: true,
      sortCaret: sortCaret,
      formatter: (cell, row) => {
        return row.EquipmentType;
      },
    },
    {
      dataField: "EquipmentSize",
      text: "Equipment size",
      sort: true,
      sortCaret: sortCaret,
      formatter: (cell, row) => {
        return row.EquipmentSize;
      },
    },
    {
      dataField: "FromCity",
      text: "PU City / State",
      sort: true,
      sortCaret: sortCaret,
      formatter: (cell, row) => {
        return row.FromCity + " / " + row.FromState;
      },
    },
    {
      dataField: "ToCity",
      text: "DEL City / State",
      sort: true,
      sortCaret: sortCaret,
      formatter: (cell, row) => {
        return row.ToCity + " / " + row.ToState;
      },
    },
    {
      dataField: "InvoiceDate",
      text: "Invoice date",
      sort: true,
      sortCaret: sortCaret,
      formatter: (cell, row) => {
        return ConvertToDateCurrentTimeZone(row.InvoiceDate);
      },
    },
    {
      dataField: "InvoiceDueDate",
      text: "Invoice due date",
      sort: true,
      sortCaret: sortCaret,
      formatter: (cell, row) => {
        return ConvertToDateCurrentTimeZone(row.InvoiceDueDate);
      },
    },
    {
      dataField: "InvoicePaid",
      text: "Invoice paid",
      sort: true,
      sortCaret: sortCaret,
      formatter: (cell, row) => {
        return row.InvoicePaid === true ? (
          <span className={`label label-lg label-light-success label-inline`}>
            Yes
          </span>
        ) : (
          <span className={`label label-lg label-light-danger label-inline`}>
            No
          </span>
        );
      },
    },
    {
      dataField: "IsHazardous",
      text: "Hazardous",
      sort: true,
      sortCaret: sortCaret,
      formatter: (cell, row) => {
        return row.IsHazardous === true ? (
          <span className={`label label-lg label-light-success label-inline`}>
            Yes
          </span>
        ) : (
          <span className={`label label-lg label-light-danger label-inline`}>
            No
          </span>
        );
      },
    },
    {
      dataField: "IsPrivate",
      text: "Private",
      sort: true,
      sortCaret: sortCaret,
      formatter: (cell, row) => {
        return row.IsPrivate === true ? (
          <span className={`label label-lg label-light-success label-inline`}>
            Yes
          </span>
        ) : (
          <span className={`label label-lg label-light-danger label-inline`}>
            No
          </span>
        );
      },
    },
    {
      dataField: "IsQuickPay",
      text: "QuickPay",
      sort: true,
      sortCaret: sortCaret,
      formatter: (cell, row) => {
        return row.IsQuickPay === true ? (
          <span className={`label label-lg label-light-success label-inline`}>
            Yes
          </span>
        ) : (
          <span className={`label label-lg label-light-danger label-inline`}>
            No
          </span>
        );
      },
    },
    {
      dataField: "IsRequireProtection",
      text: "Require protection",
      sort: true,
      sortCaret: sortCaret,
      formatter: (cell, row) => {
        return row.IsRequireProtection === true ? (
          <span className={`label label-lg label-light-success label-inline`}>
            Yes
          </span>
        ) : (
          <span className={`label label-lg label-light-danger label-inline`}>
            No
          </span>
        );
      },
    },
    {
      dataField: "Status",
      text: t("Status"),
      sort: true,
      hidden: false,
      sortCaret: sortCaret,
      formatter: columnFormatters.StatusColumnFormatter,
    },
    {
      dataField: "Action",
      text: t("Action"),
      sort: true,
      formatter: (cell, row) => {
        return (
          <Dropdown className="dropdown-inline position-unset" alignRight>
            <Dropdown.Toggle
              as={DropdownCustomToggler}
              id="dropdown-toggle-top"
            >
              <i className="ki ki-bold-more-hor" />
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu dropdown-menu-sm dropdown-menu-right">
              <ul className="navi navi-hover py-5">
                {row.StatusCode === "DL" ? (
                  <li className="navi-item">
                    <a
                      href={() => false}
                      onClick={() => {
                        setSelectedInvoice({ Code: row.Code, Id: row.Id });
                        setShowModalPaid(true);
                      }}
                      className="navi-link"
                    >
                      <span
                        style={{ cursor: "pointer" }}
                        className={`svg-icon svg-icon-md svg-icon-success mr-2`}
                      >
                        <SVG
                          src={toAbsoluteUrl(
                            `/media/svg/icons/Code/Done-circle.svg`
                          )}
                        />
                      </span>
                      <span className="navi-text">Mark as paid</span>
                    </a>
                  </li>
                ) : (
                  ""
                )}
                <li className="navi-item">
                  <a
                    href={() => false}
                    onClick={() => {
                      setshowModalInvoice(true);
                      setselectedInvoicePrint(row)
                    }}
                    className="navi-link"
                  >
                    <span
                      style={{ cursor: "pointer" }}
                      className={`svg-icon svg-icon-md svg-icon-primary mr-2`}
                    >
                      <SVG
                        src={toAbsoluteUrl(`/media/svg/icons/Files/File.svg`)}
                      />
                    </span>
                    <span className="navi-text">Print invoice</span>
                  </a>
                </li>
              </ul>
            </Dropdown.Menu>
          </Dropdown>
        );
      },
    },
  ];
  const GetHandlerTableChange = (type, newState) => {
    if (type === "sort") {
      let values = { ...initFilter };
      values.sortField = newState.sortField;
      values.sortOrder = newState.sortOrder;
      getInvoicesList(values);
    }
    if (type === "pagination") {
      let values = { ...initFilter };
      values.sizePerPage = newState.sizePerPage;
      values.page = newState.page === undefined ? 1 : newState.page;
      getInvoicesList(values);
    }
  };
  return (
    <>
      <LoadingDialog isLoading={isLoadingAuth} text="Loading ..." />
      <Helmet>
        <meta charSet="utf-8" />
        <title>{t("Shipper")} | My invoices</title>
      </Helmet>
      <Row>
        <Col xl="12">
          <div className="card mb-5">
            <div className="card-body card-body pt-10">
              <div className="col-md-12 row">
                <div className="col-lg-3">
                  <ReactSelect
                    isMulti
                    name="modeIds"
                    id="modeIds"
                    options={ViewModelOptions?.Modes?.map((a) => {
                      return {
                        value: a.Id,
                        label: a.Name,
                      };
                    })}
                    onChange={(e) => {
                      var obj = { ...initFilter };
                      obj.modeId = e === null ? [] : e;
                      getInvoicesList(obj);
                    }}
                  />
                  <small className="form-text text-muted">
                    <b>{t("Filter")}</b> by mode
                  </small>
                </div>
                <div className="col-md-3">
                  <ReactSelect
                    name="filterDate"
                    id="filterDate"
                    options={DateFiltersList}
                    onChange={(e) => {
                      var obj = { ...initFilter };
                      obj.filterDate = e?.value;
                      getInvoicesList(obj);
                    }}
                  />
                  <small className="form-text text-muted">
                    <b>{t("Filter")}</b> by date
                  </small>
                </div>
                <div className="col-lg-3">
                  <RangeDatePicker
                    startDate={
                      initFilter.startDate !== null
                        ? moment(initFilter.startDate).format("YYYY-MM-DD")
                        : null
                    }
                    endDate={
                      initFilter.endDate !== null
                        ? moment(initFilter.endDate).format("YYYY-MM-DD")
                        : null
                    }
                    onChange={(startDate, endDate) => {
                      var obj = { ...initFilter };
                      obj.startDate =
                        startDate === null
                          ? null
                          : moment(startDate).format("YYYY-MM-DD");
                      obj.endDate =
                        endDate === null
                          ? null
                          : moment(endDate).format("YYYY-MM-DD");
                      getInvoicesList(obj);
                    }}
                    dateFormat="MM/DD/YYYY"
                    minDate={new Date(1900, 0, 1)}
                    maxDate={new Date(2100, 0, 1)}
                    startDatePlaceholder="Start Date"
                    endDatePlaceholder="End Date"
                    disabled={false}
                    startWeekDay="monday"
                  />
                  <small className="form-text text-muted">
                    <b>{t("Date")}</b> {t("Filter")}
                  </small>
                </div>
                <div className="col-md-3">
                  <ReactSelect
                    name="paid"
                    id="paid"
                    options={arrayBoolean}
                    onChange={(e) => {
                      var obj = { ...initFilter };
                      obj.paid = e?.value;
                      getInvoicesList(obj);
                    }}
                  />
                  <small className="form-text text-muted">
                    <b>{t("Filter")}</b> by paid invoices 
                  </small>
                </div>
                <div className="col-lg-3 mt-5">
                  <input
                    type="search"
                    className="form-control"
                    name="search"
                    onChange={(e) => {
                      var obj = { ...initFilter };
                      obj.search = e?.target?.value;
                      getInvoicesList(obj);
                    }}
                  />
                  <small className="form-text text-muted">
                    <b>{t("Search")}</b> by load #
                  </small>
                </div>
              </div>
            </div>
          </div>
          <Card>
            <CardHeader title="My invoices">
              <CardHeaderToolbar>
                <Dropdown>
                  <Dropdown.Toggle
                    className="mr-5"
                    variant="success"
                    id="dropdown-basic"
                  >
                    {t("Export_as")}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item
                      onClick={() => {
                        ExportAs(
                          InvoicesList?.Shipments || [],
                          "excel",
                          "Invoices"
                        );
                      }}
                      href={"#"}
                    >
                      <i className="fas fa-file-excel mr-3"></i> Excel
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => {
                        ExportAs(
                          InvoicesList?.Shipments || [],
                          "csv",
                          "Invoices"
                        );
                      }}
                      href="#"
                    >
                      <i className="fas fa-file-csv mr-3"></i> Csv
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => {
                        ExportAs(
                          InvoicesList?.Shipments || [],
                          "json",
                          "Invoices"
                        );
                      }}
                      href="#"
                    >
                      <i className="fas fa-file mr-3"></i> Json
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </CardHeaderToolbar>
            </CardHeader>
            <CardBody>
              <div className="form-group">
                <PaginationProvider pagination={paginationFactory(initFilter)}>
                  {({ paginationProps, paginationTableProps }) => {
                    return (
                      <Pagination paginationProps={paginationProps}>
                        <BootstrapTable
                          wrapperClasses="table-responsive"
                          classes="table table-head-custom table-vertical-center overflow-hidden"
                          bootstrap4
                          bordered={false}
                          noDataIndication={
                            isLoadingAuth ? (
                              <h4 style={{ textAlign: "center" }}>
                                {t("Loading")} ...
                              </h4>
                            ) : (
                              <h4 style={{ textAlign: "center" }}>
                                {t("There_is_no_data_available_at_the_moment")}
                              </h4>
                            )
                          }
                          remote
                          keyField="Id"
                          data={InvoicesList?.Shipments || []}
                          columns={columns}
                          defaultSorted={[
                            { dataField: "Created", order: "desc" },
                          ]}
                          onTableChange={GetHandlerTableChange}
                          {...paginationTableProps}
                        >
                          <PleaseWaitMessage
                            entities={InvoicesList?.Shipments || []}
                          />
                          <NoRecordsFoundMessage
                            entities={InvoicesList?.Shipments || []}
                          />
                        </BootstrapTable>
                      </Pagination>
                    );
                  }}
                </PaginationProvider>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Modal
        size="md"
        show={ShowModalPaid}
        onHide={() => {
          setShowModalPaid(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("Update_invoice")}: {SelectedInvoice?.Code}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-12">
              <label>{t("Payment_date")}</label>
              <input
                type="datetime-local"
                className="form-control  form-control-lg"
                onChange={(e) => {
                  setInvoiceDate(ConvertToDateGMT(e.target.value));
                }}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowModalPaid(false);
            }}
          >
            {t("Close")}
          </Button>
          <Button
            variant="primary"
            disabled={isLoadingPutInvoice}
            onClick={() => {
              var myHeaders = new Headers();
              myHeaders.append(
                "Authorization",
                `Bearer ${db.read().getState()?.Token}`
              );

              myHeaders.append("Content-Type", "application/json");

              var raw = JSON.stringify({
                Date: InvoiceDate,
                Paid: true,
              });

              setisLoadingPutInvoice(true);

              return fetch(
                `${window.$apiurl}/api/Invoices/${SelectedInvoice?.Id}`,
                {
                  method: "Put",
                  headers: myHeaders,
                  body: raw,
                }
              )
                .then(async (response) => {
                  const statusCode = await response.status;
                  const contentType = response.headers.get("content-type");
                  if (
                    contentType &&
                    contentType.indexOf("application/json") !== -1
                  ) {
                    return response.json().then((data) => [statusCode, data]);
                  } else {
                    return response
                      .text()
                      .then((text) => [statusCode, { Message: "" }]);
                  }
                })
                .then((result) => {
                  if (result[0] === 200) {
                    Swal.fire(
                      t("Great"),
                      "Invoice has been updated successfully",
                      "success"
                    );
                    setShowModalPaid(false);
                    getInvoicesList(initFilter);
                  } else {
                    if (
                      result[1].ModelState !== null &&
                      result[1].ModelState !== undefined &&
                      result[1].ModelState !== ""
                    ) {
                      let modelState = result[1].ModelState;
                      if (modelState)
                        Object.keys(modelState).forEach(function(k) {
                          modelState[k].forEach((element) => {
                            Swal.fire(
                              translateAuto("Error"),
                              translateAuto(element),
                              "error"
                            );
                          });
                        });
                    } else if (
                      result[1].Message !== null &&
                      result[1].Message !== undefined &&
                      result[1].Message !== ""
                    ) {
                      Swal.fire(
                        translateAuto("Error"),
                        translateAuto(result[1].Message),
                        "error"
                      );
                    } else if (
                      result[1].error_description !== null &&
                      result[1].error_description !== undefined &&
                      result[1].error_description !== ""
                    ) {
                      Swal.fire(
                        translateAuto("Error"),
                        translateAuto(result[1].error_description),
                        "error"
                      );
                    } else {
                      Swal.fire(
                        translateAuto("Error"),
                        translateAuto("Bad_request")
                      );
                    }
                  }
                  setisLoadingPutInvoice(false);
                })
                .catch((error) => {
                  Swal.fire(
                    translateAuto("Error"),
                    translateAuto(error),
                    "error"
                  );
                  setisLoadingPutInvoice(false);
                });
            }}
          >
            Save changes
            {isLoadingPutInvoice && (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            )}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
          size="xl"
          show={showModalInvoice}
          onHide={() => {
            setshowModalInvoice(false);
          }}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {t("Invoice")}: {selectedInvoicePrint?.Code}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
              <InvoiceForm row={selectedInvoicePrint} />
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                setshowModalInvoice(false);
              }}
            >
              {"Close"}
            </Button>
          </Modal.Footer>
        </Modal>
    </>
  );
}
